import { useState } from "react";
import axios from "axios";

export default function SellerLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const submit = async () => {
    try {
      const res = await axios.post("https://haaterkaj-backend-1.onrender.com/api/seller/login", { email, password });
      if (res.data.success) {
        localStorage.setItem("sellerToken", res.data.token);
        localStorage.setItem("sellerId", res.data.seller._id);
        window.location.href = "/seller/seller-add-product";

      } else {
        alert(res.data.message);
      }
    } catch (error) {
      alert("Login failed! Check console.");
      console.log(error);
    }
  };

  return (
    <div className="max-w-md mx-auto p-6">
      <h2 className="text-xl font-bold mb-4">Seller Login</h2>

      <input className="w-full border p-2 text-black placeholder-gray-600 mb-3" onChange={e=>setEmail(e.target.value)} placeholder="Email" />
      <input type="password" className="w-full border p-2 text-black placeholder-gray-600 mb-3" onChange={e=>setPassword(e.target.value)} placeholder="Password" />

      <button onClick={submit} className="bg-amber-700 text-white px-4 py-2 rounded">
        Login
      </button>

      <p className="text-center text-sm mt-3">
        New Seller?{" "}
        <a href="/seller/signup" className="text-blue-600 underline">
          Create Account
        </a>
      </p>
    </div>
  );
}
